const storageKey = 'rw.analytics.firstTouch.v1';
const utmKeys = ['source', 'medium', 'campaign', 'term', 'content'] as const;
export type FirstTouchUtm = Partial<Record<(typeof utmKeys)[number], string>>;

function safeValue(value: string | null): string | null {
  if (!value) return null;
  const normalized = value.trim().slice(0, 100);
  return /^[\p{L}\p{N}._+:/-]+$/u.test(normalized) ? normalized : null;
}

export function captureFirstTouchUtm(storage: Storage, search: string): FirstTouchUtm {
  const existing = storage.getItem(storageKey);
  if (existing) {
    try {
      return JSON.parse(existing) as FirstTouchUtm;
    } catch {
      storage.removeItem(storageKey);
    }
  }
  const params = new URLSearchParams(search);
  const captured: FirstTouchUtm = {};
  for (const key of utmKeys) {
    const value = safeValue(params.get(`utm_${key}`));
    if (value) captured[key] = value;
  }
  if (Object.keys(captured).length > 0) storage.setItem(storageKey, JSON.stringify(captured));
  return captured;
}
